// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-n_fV","advertDetailHeaderPrice__value":"c-n_fW","advertDetailHeaderPrice__label":"c-n_fX"};